import React from "react";
import { Link } from "react-router-dom";
import PageShell from "@/components/PageShell";

export default function NotFound() {
  return (
    <PageShell title="Not found">
      <section className="min-h-[60vh] flex items-center justify-center px-6 py-20">
        <div className="text-center max-w-xl">
          <p className="eyebrow mb-5">404</p>
          <h1 className="font-display text-4xl md:text-6xl text-ink leading-tight tracking-tightish">
            The path you took doesn't lead here.
          </h1>
          <p className="font-serif italic text-ink-soft text-lg mt-5">
            Try one of the open doors.
          </p>
          <div className="mt-9 flex flex-wrap gap-3 justify-center">
            <Link to="/" className="btn-pill btn-pill-solid">Home</Link>
            <Link to="/books" className="btn-pill">Books</Link>
            <Link to="/listen" className="btn-pill">Music</Link>
            <Link to="/watch" className="btn-pill">Films</Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
